import { DefaultTypography } from '@cseo/styles';
import { mergeStyles, mergeStyleSets } from '@fluentui/react';
export var getStyles = function (props) {
    var theme = props.theme;
    return {
        root: {},
        searchbox: {},
        autoSuggestDropdown: mergeStyles({
            displayName: 'AutoSuggestDropdownStyles',
            backgroundColor: theme.palette.white,
            boxShadow: '0px 3.2px 7.2px rgba(0, 0, 0, 0.132), 0px 0.6px 1.8px rgba(0, 0, 0, 0.108)',
            borderRadius: '2px'
        }),
        searchSuggestionList: mergeStyles({
            paddingTop: '8px'
        }),
        searchSuggestionItem: {},
        errorMessage: mergeStyles({
            displayName: 'EmptyDropDown',
            paddingTop: '16px',
            paddingBottom: '16px',
            alignContent: 'center',
            textAlign: 'center'
        }),
        suggestionCategoryHeader: mergeStyles(TypeHierarchy.base, {
            displayName: 'SuggestionCategoryHeader',
            height: '32px',
            paddingRight: '16px',
            paddingLeft: '16px'
        }),
        showMoreResultsLink: mergeStyles({
            textAlign: 'center',
            color: theme.palette.themeDark,
            height: '49px',
            borderTop: "1px solid " + theme.palette.neutralLighter,
            alignItems: 'center'
        })
    };
};
export var searchBoxStyles = function (theme) {
    return {
        root: {
            backgroundColor: theme.palette.themeLighter,
            border: '1px solid transparent',
            selectors: {
                ':hover': {
                    backgroundColor: theme.palette.white,
                    border: '1px solid transparent'
                },
                ':focus-within': {
                    backgroundColor: theme.palette.white,
                    border: '1px solid transparent'
                },
                ':after': {
                    top: '0px',
                    bottom: '0px',
                    left: '0px',
                    right: '0px',
                    border: '1px solid transparent'
                }
            }
        },
        field: {
            selectors: {
                '::placeholder': {
                    color: theme.palette.themePrimary
                }
            }
        }
    };
};
export var TypeHierarchy = mergeStyleSets({
    base: DefaultTypography.base,
    body: DefaultTypography.body,
    caption: DefaultTypography.caption
});
export var EmptyDropDown = mergeStyles({
    displayName: 'EmptyDropDown',
    paddingTop: '16px',
    paddingBottom: '16px',
    alignContent: 'center',
    textAlign: 'center'
});
export var SearchLoader = function (theme) {
    return mergeStyles(EmptyDropDown, {
        displayName: 'SearchLoader',
        color: theme.palette.themePrimary
    });
};
export var SuggestionItemStyle = function (theme) {
    return {
        details: {
            paddingLeft: '12px'
        },
        primaryText: mergeStyles(TypeHierarchy.body, { color: theme.palette.neutralPrimary }),
        secondaryText: mergeStyles(TypeHierarchy.caption, { color: theme.palette.neutralSecondary })
    };
};
export var sidePadding = mergeStyles({
    displayName: 'sidePadding',
    paddingRight: '16px',
    paddingLeft: '16px'
});
export var suggestionRowHoverState = function (theme) {
    return mergeStyles({
        displayName: 'suggestionRowHoverState',
        selectors: {
            ':hover': {
                backgroundColor: theme.palette.neutralLighter
            }
        }
    });
};
export var bottomBorder = function (theme) {
    return mergeStyles({
        displayName: 'bottomBorder',
        borderBottom: "1px solid " + theme.palette.neutralLighter
    });
};
export var SuggestionRowStyle = mergeStyles({
    height: '49px',
    width: '-webkit-fill-available'
});
export var suggestionRowCommandBtnStyles = function (theme) {
    return {
        flexContainer: {
            borderBottom: "1px solid " + theme.palette.neutralLighter
        },
        root: mergeStyles(sidePadding, SuggestionRowStyle, suggestionRowHoverState(theme))
    };
};
export var RecentSearchBtnStyles = function (theme) {
    return {
        icon: {
            fontSize: '28px',
            marginLeft: '0px',
            marginRight: '16px',
            color: theme.palette.neutralPrimaryAlt
        },
        root: mergeStyles(sidePadding, SuggestionRowStyle, suggestionRowHoverState(theme)),
        flexContainer: {
            borderBottom: "1px solid " + theme.palette.neutralLighter
        }
    };
};
export var zeroSidePadding = mergeStyles({
    displayName: 'zeroSidePadding',
    paddingLeft: '0px',
    paddingRight: '0px'
});
export var fullSearchResultsSeparatorStyles = mergeStyles({
    displayName: 'fullSearchResultsSeparatorStyles',
    paddingTop: '0px',
    paddingBottom: '0px',
    height: '1px'
});
export var RecentSearchText = function (theme) {
    return mergeStyles(DefaultTypography.body, {
        displayName: 'RecentSearchText',
        color: theme.palette.neutralPrimary,
        lineHeight: '19px'
    });
};
export var SuggestionCategoryHeaderText = function (theme) {
    return mergeStyles(TypeHierarchy.base, {
        displayName: 'SuggestionCategoryHeaderText',
        color: theme.palette.neutralDark,
        lineHeight: '32px'
    });
};
export var ShowMoreLinkStyles = mergeStyles({
    border: 'none',
    marginTop: '11px'
});
export var SearchPersonaCoinStylesSqaure = {
    image: {
        borderRadius: 2
    },
    initials: {
        borderRadius: 2
    }
};
export var SearchPersonaCoinStylesRound = {
    image: {
        borderRadius: 25
    },
    initials: {
        borderRadius: 25
    }
};
export var divGlobalSearch = mergeStyles({
    displayName: 'divGlobalSearch',
    paddingTop: '4% !important',
    height: '90vh !important'
});
export var announcedBGColor = function (theme) {
    return {
        screenReaderText: {
            backgroundColor: theme.palette.white
        }
    };
};
//# sourceMappingURL=GlobalSearch.styles.js.map